module.exports = __webpack_public_path__ + "media/horse-whinny-good.aa7e03af.mp3";